document.addEventListener('DOMContentLoaded', initFormFields);

function initFormFields() {
  const selectFields = document.querySelectorAll('.form-field--select');
  if (selectFields.length) {
    selectFields.forEach((field) => {
      togglePlaceholderSelectClass();
      field.addEventListener('change', togglePlaceholderSelectClass);
      function togglePlaceholderSelectClass() {
        if (field.value == '') {
          field.classList.add('form-field--placeholder-selected');
        } else {
          field.classList.remove('form-field--placeholder-selected');
        }
      }
    });
  }
}
